import { Helpers } from '../../helpers';
import { IConstraintDrillFracInterferenceDetail } from '../../interfaces/iconstraint-drill-frac-interference-detail';
import { Area } from '../area';
import { ConstraintDrillFracInterference } from '../constraint-drill-frac-interference';
import { ConstraintDrillFracInterferenceInteractingTargetFormation } from '../constraint-drill-frac-interference-interacting-target-formation';
import { TargetFormation } from '../target-formation';

export class ConstraintDrillFracInterferenceDetailBase {
  ConstraintDrillFracInterferenceDetailId: number;
  ConstraintDrillFracInterferenceId: number;
  TargetFormationId: number;
  OffsetXDistance: number | null;
  OffsetYDistance: number | null;
  AreaId: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  ConstraintDrillFracInterferenceInteractingTargetFormations_ConstraintDrillFracInterferenceDetail?: Array<ConstraintDrillFracInterferenceInteractingTargetFormation> | null;
  Area?: Area;
  ConstraintDrillFracInterference?: ConstraintDrillFracInterference;
  TargetFormation?: TargetFormation;

  constructor(item?: IConstraintDrillFracInterferenceDetail) {
    if (item) {

      this.ConstraintDrillFracInterferenceDetailId = item.ConstraintDrillFracInterferenceDetailId;
      this.ConstraintDrillFracInterferenceId = item.ConstraintDrillFracInterferenceId;
      this.TargetFormationId = item.TargetFormationId;
      this.OffsetXDistance = item.OffsetXDistance;
      this.OffsetYDistance = item.OffsetYDistance;
      this.AreaId = item.AreaId;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.ConstraintDrillFracInterferenceInteractingTargetFormations_ConstraintDrillFracInterferenceDetail = Helpers.createClassArray(ConstraintDrillFracInterferenceInteractingTargetFormation, item.ConstraintDrillFracInterferenceInteractingTargetFormations_ConstraintDrillFracInterferenceDetail);
      this.Area = new Area(item.Area);
      this.ConstraintDrillFracInterference = new ConstraintDrillFracInterference(item.ConstraintDrillFracInterference);
      this.TargetFormation = new TargetFormation(item.TargetFormation);
    }
  }
}